<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import util from '@/libs/util'
	import { debounce } from 'lodash'
	export default {
		name: 'app',
		watch: {
			'$i18n.locale': 'i18nHandle',
			// 顶栏显隐不会改变浏览器高度，必须主动通知依赖 winHeight 的页面。
			'$store.state.d2admin.fullscreen.active': 'updateWinHeight'
		},
		created() {
			this.i18nHandle(this.$i18n.locale)
			this.autoWsLogin() //检查ws连接状态，刷新后ws会断，判断之前是否是登陆的，是就重新连接
			window.addEventListener("beforeunload", this.handleBeforeUnload) //增加 页面关闭阻止的监听
		},
		mounted() {
			this.autoGetWinHeight() //自动获取浏览器高度
			
		},
		// 清理全局监听和防抖尾调用，避免销毁后继续写入页面高度。
		beforeDestroy() {
			window.removeEventListener("beforeunload", this.handleBeforeUnload) //移除 页面关闭阻止的监听
			window.removeEventListener('resize', this.resizeHeightHandler)
			if (this.resizeHeightHandler) this.resizeHeightHandler.cancel()
		},
		methods: {
			i18nHandle(val, oldVal) {
				util.cookies.set('lang', val)
				document.querySelector('html').setAttribute('lang', val)
			},
			// 初次挂载和窗口缩放复用同一高度计算，缩放保留 200ms 防抖。
			autoGetWinHeight() {
				this.updateWinHeight()
				this.resizeHeightHandler = debounce(this.updateWinHeight, 200)
				window.addEventListener('resize', this.resizeHeightHandler)
			},
			// 既有列表公式已扣除 60px 顶栏；隐藏时补回，兼容所有现有页面。
			updateWinHeight() {
				const releasedHeight = this.$store.state.d2admin.fullscreen.active ? 60 : 0
				this.$store.commit('d2admin/mystore/setWinHeight', window.innerHeight + releasedHeight)
			},
			//检查ws连接状态，刷新后ws会断，判断之前是否是登陆的，是就重新连接
			autoWsLogin() {
				let sup = this.$util.cookies.get('WsSupport')
				let state = this.$util.cookies.get('WsLoginState')
				if (sup && state) {
					this.$ws.wsConnect()
				}
			},
			//页面关闭阻止的监听事件
			handleBeforeUnload(event) {
				if (process.env.NODE_ENV != 'development') {
					event.returnValue = "你确定要离开这个页面吗?"
				}
			},
		},



	}
</script>

<style lang="scss" scoped>
	@import '~@/assets/style/public-class.scss';
	@import '~@/assets/vxe-table/style.css'; //调整表格的滚动条
	@import '~@/assets/elementui/style.css'; //调整el的滚动条
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/App.vue"
}
</vue-filename-injector>
